import { Module } from 'vuex';
import { IRootState } from '@types';

import Env from '@lib/Env';

import { AVideoApi } from '@/api';
import { Actor } from '@/types';

const store: Module<any, IRootState> = {
    state: {
        video: <Actor.Video>{},
        video_request: <Actor.VideoRequest>{},
    },

    mutations: {
        setVideo: (state, video: Actor.Video) => (state.video = video),
    },

    getters: {
        getVideoRequestVideo: (state): Actor.Video => state.video,
        getVideoRequest: (state): Actor.VideoRequest => state.video_request,
    },

    actions: {
        storeVideoRequestVideo({ commit, getters }, data: any): Promise<any> {
            return new Promise((resolve, reject) => {
                AVideoApi.storeVideoRequestVideo(data)
                    .then((response) => {
                        if (getters.getActor) {
                            commit('setVideoRequests', response.data.video_request);
                        }
                        resolve(true);
                    })
                    .catch((err) => {
                        Env.log.error(err);
                        reject(err);
                    });
            });
        },

        removeVideoRequestVideo({ commit, getters }, video: any): Promise<any> {
            return new Promise((resolve, reject) => {
                AVideoApi.removeVideoRequestVideo(video)
                    .then((response) => {
                        if (getters.getActor) {
                            commit('setVideoRequests', response.data.video_request);
                        }
                        resolve(true);
                    })
                    .catch((err) => {
                        Env.log.error(err);
                        reject(err);
                    });
            });
        },

        loadVideo(store, hash: string): Promise<any> {
            return new Promise((resolve, reject) => {
                AVideoApi.loadVideo(hash)
                    .then((response) => {
                        resolve(response.data.video);
                    })
                    .catch((err) => {
                        Env.log.error(err);
                        reject(err);
                    });
            });
        },

        loadVideoRequestDetail({ commit }, data: any): Promise<any> {
            return new Promise((resolve, reject) => {
                const promise = data.character_id
                    ? AVideoApi.loadVideoRequestDetailByCharacter(data.character_id, data.query)
                    : AVideoApi.loadVideoRequestDetail(data.hash, data.query);
                promise
                    .then((response) => {
                        commit('setVideo', response.data);
                        resolve(response.data);
                    })
                    .catch((err) => {
                        Env.log.error(err);
                        reject(err);
                    });
            });
        },
    },
};

export default store;
